<template>
  <div class="scroll-wrapper custom-fields-page">
    <el-card class="custom-fields-container custom-fields-card">
      <div class="custom-fields-header">
        <span class="custom-fields-title">Пользовательские поля</span>
        <el-button type="primary" @click="showAddModal = true">Добавить поле</el-button>
      </div>
      <el-tabs v-model="selectedTab" class="custom-fields-tabs">
      <el-tab-pane
        v-for="entity in entities"
        :key="entity.value"
        :label="entity.label"
        :name="entity.value"
      >
        <div class="custom-fields-table-shell">
          <CustomFieldsTable
            :fields="filteredFields(entity.value)"
            :entity="entity.value"
            @remove="removeFieldByEntity"
            @edit="openEditField"
          />
        </div>
      </el-tab-pane>
      </el-tabs>
    </el-card>

  <!-- Диалог добавления поля -->
    <el-dialog v-model="showAddModal" title="Добавить поле" width="500px" class="custom-fields-dialog" @close="resetForm">
    <el-form :model="newField" label-width="auto">
      <el-form-item label="Сущность">
        <el-select v-model="newField.entity" placeholder="Выберите сущность">
          <el-option
            v-for="entity in entities"
            :key="entity.value"
            :label="entity.label"
            :value="entity.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="Название">
        <el-input v-model="newField.label"/>
      </el-form-item>
      <el-form-item label="Тип">
        <el-select v-model="newField.type" placeholder="Тип" @change="onTypeChange">
          <el-option label="Текст" value="text"/>
          <el-option label="Многострочный текст" value="textarea"/>
          <el-option label="Число" value="number"/>
          <el-option label="Дата" value="date"/>
          <el-option label="Дата и время" value="datetime"/>
          <el-option label="Выпадающий список" value="select"/>
          <el-option label="Чекбокс" value="checkbox"/>
          <el-option label="Переключатель" value="switch"/>
          <el-option label="Радио" value="radio"/>
          <el-option label="Ползунок" value="slider"/>
          <el-option label="Мультисписок" value="multiselect"/>
        </el-select>
      </el-form-item>
      <el-form-item v-if="newField.entity === 'appointment'" label="Показывать на этапе">
        <el-select v-model="newField.stage" placeholder="Выберите этап">
          <el-option label="Создание" value="create" />
          <el-option label="Закрытие" value="close" />
          <el-option label="Оба" value="both" />
        </el-select>
      </el-form-item>
      <!-- Настройки для select/radio/multiselect -->
      <el-form-item
        v-if="['select','radio','multiselect'].includes(newField.type)"
        label="Опции"
      >
        <div v-for="(option, i) in newField.optionsArr" :key="i" style="display: flex; align-items: center; margin-bottom: 8px; width: 100%;">
          <el-input v-model="newField.optionsArr[i]" placeholder="Введите вариант" style="width: 100%;" />
          <el-button @click="removeOption(i)" :icon="Remove" circle type="danger" size="small" style="margin-left: 6px;" :disabled="newField.optionsArr.length === 1"/>
        </div>
        <el-button @click="addOption" icon="el-icon-plus" type="primary" size="small" plain>Добавить вариант</el-button>
      </el-form-item>
      <!-- Чекбоксы для number/slider -->
      <el-form-item v-if="['number','slider'].includes(newField.type)" label="Диапазон и единицы">
        <el-checkbox v-model="showLimits" style="margin-bottom: 8px;">Ограничить диапазон</el-checkbox>
        <div v-if="showLimits" style="display: flex; align-items: center; margin-bottom: 8px;">
          <el-input-number v-model="newField.min" placeholder="Мин." :min="0" style="width:120px;"/>
          <span style="margin:0 8px;">—</span>
          <el-input-number v-model="newField.max" placeholder="Макс." :min="0" style="width:120px;"/>
        </div>
        <el-checkbox v-model="showUnit">Показать единицу измерения</el-checkbox>
        <div v-if="showUnit" style="margin-top: 8px;">
          <el-input v-model="newField.unit" placeholder="шт., ₽, мин и т.д."/>
        </div>
      </el-form-item>
      <!-- Настройки для placeholder -->
      <el-form-item v-if="['text','textarea'].includes(newField.type)" label="Подсказка в поле">
        <el-input v-model="newField.placeholder" placeholder="Подсказка в поле"/>
      </el-form-item>
      <el-form-item label="Обязательное">
        <el-switch v-model="newField.required"/>
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button @click="showAddModal = false">Отмена</el-button>
      <el-button type="primary" @click="addField">Добавить</el-button>
    </template>
    </el-dialog>

    <el-dialog v-model="showEditModal" title="Редактировать поле" width="500px" class="custom-fields-dialog" @close="resetEditForm">
    <el-form :model="editField" label-width="auto" v-if="editField">
      <el-form-item label="ID поля">
        <el-input :value="editField.id" disabled />
      </el-form-item>
      <el-form-item label="Сущность">
        <el-select v-model="editField.entity" disabled>
          <el-option v-for="entity in entities" :key="entity.value" :label="entity.label" :value="entity.value"/>
        </el-select>
      </el-form-item>
      <el-form-item label="Название">
        <el-input v-model="editField.label"/>
      </el-form-item>
      <el-form-item label="Тип">
        <el-select v-model="editField.type" disabled>
          <el-option label="Текст" value="text"/>
          <el-option label="Многострочный текст" value="textarea"/>
          <el-option label="Число" value="number"/>
          <el-option label="Дата" value="date"/>
          <el-option label="Дата и время" value="datetime"/>
          <el-option label="Выпадающий список" value="select"/>
          <el-option label="Чекбокс" value="checkbox"/>
          <el-option label="Переключатель" value="switch"/>
          <el-option label="Радио" value="radio"/>
          <el-option label="Цвет" value="color"/>
          <el-option label="Ползунок" value="slider"/>
          <el-option label="Мультисписок" value="multiselect"/>
        </el-select>
      </el-form-item>
      <el-form-item v-if="editField.entity === 'appointment'" label="Показывать на этапе">
        <el-select v-model="editField.stage" placeholder="Выберите этап">
          <el-option label="Создание" value="create" />
          <el-option label="Закрытие" value="close" />
          <el-option label="Оба" value="both" />
        </el-select>
      </el-form-item>
      <!-- Настройки для select/radio/multiselect -->
      <el-form-item
        v-if="['select','radio','multiselect'].includes(editField.type)"
        label="Опции">
        <div v-for="(option, i) in editField.options" :key="i" style="display: flex; align-items: center; margin-bottom: 8px;">
          <el-input v-model="editField.options[i]" placeholder="Введите вариант" style="width: 85%;" />
        </div>
      </el-form-item>
      <!-- Чекбоксы для number/slider -->
      <el-form-item v-if="['number','slider'].includes(editField.type)" label="Диапазон и единицы">
        <el-checkbox v-model="editShowLimits" style="margin-bottom: 8px;">Ограничить диапазон</el-checkbox>
        <div v-if="editShowLimits" style="display: flex; align-items: center; margin-bottom: 8px;">
          <el-input-number v-model="editField.min" placeholder="Мин." :min="0" style="width:120px;"/>
          <span style="margin:0 8px;">—</span>
          <el-input-number v-model="editField.max" placeholder="Макс." :min="0" style="width:120px;"/>
        </div>
        <el-checkbox v-model="editShowUnit">Показать единицу измерения</el-checkbox>
        <div v-if="editShowUnit" style="margin-top: 8px;">
          <el-input v-model="editField.unit" placeholder="шт., ₽, мин и т.д."/>
        </div>
      </el-form-item>
      <!-- Настройки для placeholder -->
      <el-form-item v-if="['text','textarea'].includes(editField.type)" label="Подсказка в поле">
        <el-input v-model="editField.placeholder" placeholder="Подсказка в поле"/>
      </el-form-item>
      <el-form-item label="Обязательное">
        <el-switch v-model="editField.required"/>
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button @click="showEditModal = false">Отмена</el-button>
      <el-button type="primary" @click="saveEditField">Сохранить</el-button>
    </template>
    </el-dialog>
  </div>
</template>

<script>
import CustomFieldsTable from '@/components/util/custom_fields/CustomFieldsTable.vue'
import { mapActions, mapState } from 'vuex'
import { Remove } from '@element-plus/icons-vue'

export default {
  name: 'CustomFields',
  components: { CustomFieldsTable },
  data() {
    return {
      showAddModal: false,
      showEditModal: false,
      selectedTab: 'client',
      entities: [
        { label: 'Клиент', value: 'client' },
        { label: 'Запись', value: 'appointment' }
      ],
      newField: {
        entity: '',
        label: '',
        type: 'text',
        options: '',
        optionsArr: [''],
        min: null,
        max: null,
        unit: '',
        placeholder: '',
        required: false,
        stage: 'create'
      },
      editField: null,
      showLimits: false,
      showUnit: false,
      editShowLimits: false,
      editShowUnit: false
    }
  },
  computed:{
    Remove() {
      return Remove
    },
    ...mapState('custom_fields', ['fields']),
    filteredFields() {
      return entity => this.fields.filter(f => f.entity === entity);
    }
  },
  mounted() {
    // Загружаем все поля при открытии
    this.fetchCustomFields();
  },
  methods: {
    ...mapActions('custom_fields', ['fetchCustomFields', 'saveCustomField', 'updateCustomField', 'deleteCustomField', 'updateSortCustomFields']),
    addOption() {
      this.newField.optionsArr.push('');
    },
    removeOption(i) {
      if (this.newField.optionsArr.length > 1) this.newField.optionsArr.splice(i, 1);
    },
    onTypeChange() {
      if (['select', 'radio', 'multiselect'].includes(this.newField.type)) {
        this.newField.optionsArr = [''];
      }
      // Reset showLimits and showUnit when type changes
      if (!['number', 'slider'].includes(this.newField.type)) {
        this.showLimits = false;
        this.showUnit = false;
      }
    },
    async removeFieldByEntity(field) {
      await this.deleteCustomField(field.id); // deleteCustomField должен быть экшеном стора
      this.$message.success('Поле удалено');
    },
    updateFields(newFields) {
      this.fields = newFields
    },
    resetForm() {
      this.newField = {
        entity: '',
        label: '',
        type: 'text',
        options: '',
        optionsArr: [''],
        min: null,
        max: null,
        unit: '',
        placeholder: '',
        required: false,
        stage: 'create'
      };
      this.showLimits = false;
      this.showUnit = false;
    },
    async addField() {
      if (!this.newField.label || !this.newField.entity) {
        this.$message.error('Заполните название и выберите сущность.');
        return;
      }

      // Валидация для select/radio/multiselect
      if (['select', 'radio', 'multiselect'].includes(this.newField.type)) {
        const validOptions = this.newField.optionsArr.filter(v => v.trim());
        if (validOptions.length === 0) {
          this.$message.error('Пожалуйста, добавьте хотя бы одну опцию.');
          return;
        }
      }

      // Валидация для number/slider с учетом showLimits
      if (['number', 'slider'].includes(this.newField.type) && this.showLimits) {
        if ((this.newField.min === null || this.newField.min === '') &&
          (this.newField.max === null || this.newField.max === '')) {
          this.$message.error('Пожалуйста, укажите минимум или максимум.');
          return;
        }
      }

      // Собираем объект поля
      const field = {
        entity: this.newField.entity,
        label: this.newField.label,
        type: this.newField.type,
        options: ['select', 'radio', 'multiselect'].includes(this.newField.type)
          ? this.newField.optionsArr.filter(v => v.trim())
          : [],
        min: (this.newField.type === 'number' || this.newField.type === 'slider') && this.showLimits ? this.newField.min : null,
        max: (this.newField.type === 'number' || this.newField.type === 'slider') && this.showLimits ? this.newField.max : null,
        unit: (this.newField.type === 'number' || this.newField.type === 'slider') && this.showUnit ? this.newField.unit : '',
        placeholder: ['text', 'textarea'].includes(this.newField.type) ? this.newField.placeholder : '',
        required: this.newField.required,
        stage: this.newField.entity === 'appointment' ? this.newField.stage : undefined
      }

      // Сохраняем через стор (экшен должен сам обновить this.fields)
      await this.saveCustomField(field)

      // Переключаемся на вкладку нужной сущности
      this.selectedTab = field.entity

      // Закрываем модалку и сбрасываем форму
      this.showAddModal = false
      this.resetForm();
    },
    openEditField(field) {
      this.editField = { ...field };
      // Initialize range and unit toggles for the edit form.
      this.editShowLimits = (field.min !== null && field.min !== '') || (field.max !== null && field.max !== '');
      this.editShowUnit = field.unit !== null && field.unit !== '';
      this.showEditModal = true;
    },
    resetEditForm() {
      this.editField = null;
      this.editShowLimits = false;
      this.editShowUnit = false;
    },
    async saveEditField() {
      if (!this.editField.label) {
        this.$message.error('Название не может быть пустым')
        return
      }
      // Если чекбокс Ограничить диапазон снят - очищаем min и max
      if (!this.editShowLimits) {
        this.editField.min = null;
        this.editField.max = null;
      }
      // Если чекбокс Показать единицу измерения снят - очищаем unit
      if (!this.editShowUnit) {
        this.editField.unit = '';
      }
      // Для select/radio/multiselect в editField.options уже есть данные, нет редактирования optionsArr
      if (this.editField.entity === 'appointment' && !this.editField.stage) {
        this.editField.stage = 'create';
      }
      await this.updateCustomField(this.editField)
      this.showEditModal = false
      this.resetEditForm()
      this.$message.success('Поле обновлено')
    }
  }
}
</script>
<style scoped>
.custom-fields-page {
  height: 100%;
  overflow-y: auto;
  padding: 24px 18px 28px;
  background:
    radial-gradient(circle at top left, rgba(22, 61, 124, 0.28), transparent 34%),
    linear-gradient(180deg, #091325 0%, #07111f 100%);
}

.custom-fields-container {
  width: min(1120px, 100%);
  margin: 0 auto;
}

.custom-fields-card {
  border: 1px solid rgba(110, 146, 214, 0.18);
  border-radius: 24px;
  background: linear-gradient(180deg, rgba(10, 26, 52, 0.96), rgba(7, 18, 36, 0.94));
  box-shadow: 0 24px 48px rgba(2, 8, 18, 0.34);
}

.custom-fields-card :deep(.el-card__body) {
  padding: 20px;
}

.custom-fields-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.custom-fields-title {
  color: #f5f9ff;
  font-family: var(--ui-font-family-base);
  font-size: 30px;
  font-weight: 500;
}

.custom-fields-tabs {
  margin-top: 24px;
}

.custom-fields-table-shell {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.custom-fields-page :deep(.el-tabs__item) {
  color: rgba(174, 194, 230, 0.7);
}

.custom-fields-page :deep(.el-tabs__item.is-active),
.custom-fields-page :deep(.el-tabs__item:hover) {
  color: #22c0ff;
}

.custom-fields-page :deep(.el-tabs__active-bar) {
  background: linear-gradient(135deg, #22c0ff, #2b7cff);
}

.custom-fields-page :deep(.el-button--primary) {
  border: none;
  border-radius: 14px;
  background: linear-gradient(135deg, #22c0ff, #2b7cff);
  box-shadow: 0 16px 32px rgba(0, 123, 255, 0.2);
}

.custom-fields-dialog.el-dialog {
  width: min(560px, calc(100vw - 24px)) !important;
  border-radius: 24px;
  overflow: hidden;
  border: 1px solid rgba(110, 146, 214, 0.2);
  background: linear-gradient(180deg, rgba(12, 28, 55, 0.98), rgba(7, 18, 36, 0.98));
}

.custom-fields-dialog :deep(.el-dialog__header),
.custom-fields-dialog :deep(.el-dialog__body),
.custom-fields-dialog :deep(.el-dialog__footer) {
  background: transparent;
}

.custom-fields-dialog :deep(.el-dialog__title),
.custom-fields-dialog :deep(.el-form-item__label),
.custom-fields-dialog :deep(.el-checkbox__label) {
  color: #eef5ff;
}

.custom-fields-dialog :deep(.el-input__wrapper),
.custom-fields-dialog :deep(.el-select__wrapper),
.custom-fields-dialog :deep(.el-textarea__inner),
.custom-fields-dialog :deep(.el-input-number) {
  background: rgba(10, 26, 52, 0.96) !important;
  box-shadow: inset 0 0 0 1px rgba(110, 146, 214, 0.16) !important;
}

.custom-fields-dialog :deep(.el-input__inner),
.custom-fields-dialog :deep(.el-select__placeholder),
.custom-fields-dialog :deep(.el-textarea__inner),
.custom-fields-dialog :deep(.el-input-number__decrease),
.custom-fields-dialog :deep(.el-input-number__increase) {
  color: #eef5ff !important;
}

.scroll-wrapper {
  height: 100%;
  overflow-y: auto;
}

@media (max-width: 768px) {
  .custom-fields-page {
    padding: 16px 12px 22px;
  }

  .custom-fields-card :deep(.el-card__body) {
    padding: 16px;
  }

  .custom-fields-header {
    flex-direction: column;
    align-items: stretch;
  }

  .custom-fields-title {
    font-size: 26px;
  }
}
</style>

